import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

/**
 * Motyw jasny/ciemny — mechanizm 1:1 z mPracownika i Serwisu FTP: atrybut `data-theme` na <html>,
 * całą resztę robią tokeny z global.css. Wybór zostaje w localStorage pod tym samym kluczem
 * ("app-theme"), więc osoba korzystająca z kilku aplikacji intranetu ma spójne ustawienie.
 *
 * Start bez zapisanego wyboru idzie za preferencją systemu — DOKŁADNIE tak samo, jak liczy to
 * skrypt anty-mignięciowy w public/index.html. Gdyby te dwa miejsca się rozjechały, przy wejściu
 * mignąłby jasny interfejs, zanim React ustawiłby swój stan.
 */
const ThemeContext = createContext(null);

const STORAGE_KEY = "app-theme";

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved === "light" || saved === "dark") {
            return saved;
        }
        return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    });

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        localStorage.setItem(STORAGE_KEY, theme);
    }, [theme]);

    const toggleTheme = useCallback(() => {
        setTheme((current) => (current === "light" ? "dark" : "light"));
    }, []);

    const value = useMemo(
        () => ({ theme, isDark: theme === "dark", toggleTheme, setTheme }),
        [theme, toggleTheme]
    );

    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () =>
    useContext(ThemeContext) || { theme: "light", isDark: false, toggleTheme: () => {}, setTheme: () => {} };
